<template>
  <div class="akl">
    <div class="bod-view-txt">
      <div class="os_noticeRes">
        <div class="widM padTM cont_Wrap">
          <!-- 설문 헤더 -->
          <SurveyHeader />

          <!-- 설문 참가자 정보 -->
          <SurveyParticipantInfo />

          <!-- 참가 약관 -->
          <SurveyConsent v-if="existAttendant" />

          <!-- 참가 액티비티 예약 -->
          <SurveyActivityList v-if="existAttendant" />
          
          <hr style="border-top:1px solid #ddd; background:#f4f4f4;">

          <div class="widM txtC marTML" v-if="mode === 'E' || existAttendant">
            <button
              class="bt-akl-blue large NCACroa_submit"
              @click="submitSurvey"
            >{{ submitBtnText }}</button>
          </div>
          <div class="padM disIb"></div>
        </div>
        <SurveyPopupLayer v-if="survey_popup" />
      </div>
    </div>
    <SurveyLoading v-if="survey_loading" />
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import { SURVEY, FETCH_DATAS, EXIST_ATTENDANT, SET_ABO_UID, SET_LOADING, VALIDATE_DATA, SUBMIT_SURVEY, UPDATE_ACTIVITY_REMAIN_NUM, ACTIVITY_QUESTIONS } from '@/store/actions/survey'
import { SurveyHeader, SurveyParticipantInfo, SurveyConsent, SurveyActivityList, SurveyLoading, SurveyPopupLayer } from './components'
import { getErrorMsg } from '@/utils/survey'

export default {
  name: 'Survey',
  components: {
    SurveyHeader,
    SurveyParticipantInfo,
    SurveyConsent,
    SurveyActivityList,
    SurveyLoading,
    SurveyPopupLayer,
  },
  computed: {
    ...mapState(SURVEY, {
      abo_uid: state => state.abo_uid,
      survey_loading: state => state.loading,
      survey_popup: state => state.popup.open,
      mode: state => state.mode
    }),
    ...mapGetters(SURVEY, {
      existAttendant: EXIST_ATTENDANT,
      activities: ACTIVITY_QUESTIONS
    }),
    submitBtnText() {
      return this.mode === 'W' ? '제출' : '저장';
    }
  },
  methods: {
    /**
     * survey 조회 및 설문 데이터 세팅
     */
    async fetchDatas() { // 
      this.$store.commit(`${SURVEY}/${SET_LOADING}`, true);
      // const s_code = this.$route.params.code; // survey 코드
      const s_code = 'PF22' // survey 코드
      const wave_number = this.$route.params.wave_number; // survey 회차 수
      try {
        await this.$store.dispatch(`${SURVEY}/${FETCH_DATAS}`, { s_code, wave_number, abo_uid: this.abo_uid });
      } catch (error) {
        alert(error.message);
        window.location.href = process.env.AMWAY_ROOT_URL;
      }
    },
    async submitSurvey() {
      try {
        // 입력 데이터 체크
        const errorMsg = await this.$store.dispatch(`${SURVEY}/${VALIDATE_DATA}`);
        if(errorMsg) {
          alert(errorMsg);
          return;
        }
        
        const { data } = await this.$store.dispatch(`${SURVEY}/${SUBMIT_SURVEY}`);
        if(data.status !== 200 && data.status !== 201) {
          if(data.message === 'SURVEY_NOT_FOUND' || data.message === 'SURVEY_NOT_OPENED' || data.message === 'SURVEY_ALREADY_CLOSED') {
            alert(getErrorMsg(data.status, data.message));
            window.location.href = process.env.AMWAY_ROOT_URL;
            return;
          } else if(data.message === 'ACTIVITY_NO_REMAINING') { // 액티비티 잔여 인원 부족
            const errMsg = getErrorMsg(data.status, data.message);
            const alertMsg = data.list.map(activity => `${this.activities[activity.sq_code].title} ${activity.value}에 ${errMsg}`).join('\n');
            await this.$store.dispatch(`${SURVEY}/${UPDATE_ACTIVITY_REMAIN_NUM}`, data.list);
            throw new Error(alertMsg);
          } else {
            throw new Error(getErrorMsg(data.status, data.message));
          }
        }
  
        alert('입력해주신 정보를 저장하는데 성공했습니다.');
        this.$router.go(this.$router.currentRoute);
      } catch (error) {
        alert(error.message);
        this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
      }
    }
  },
  async mounted() {
    await this.fetchDatas();
    this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
  },
  /**
   * 페이지 라우팅 되기 전에
   * SSO Login 체크, 서베이 코드 및 서베이 회차 validation
   * 
   */
  async beforeRouteEnter(to, from, next) {
    try {
        // SSO Login 체크
        const { data } = await axios.get(`${process.env.OCC_ROOT_URL}/sso/authorizeEvent`, { withCredentials: true });
        if(data.header.status === 'ERROR') {
          window.location.href = `${process.env.AMWAY_ROOT_URL}/login`;
        } else {
          // const s_code = to.params.code;
          const wave_number = to.params.wave_number;
          const abo_uid = atob(data.customerUid);
          if(Number(wave_number) === NaN || Number(wave_number) < 1) {
            alert('정상적인 접근이 아닙니다.');
            window.location.href = process.env.AMWAY_ROOT_URL;
            return next(false);
          } else if(abo_uid === '') {
            alert('암웨이 사이트 로그인이 필요합니다.');
            window.location.href = `${process.env.AMWAY_ROOT_URL}/login`;
            return next(false);
          }
          
          return next(vm => {
            vm.$store.commit(`${SURVEY}/${SET_ABO_UID}`, abo_uid);
          });
        }
      } catch (error) {
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.');
        window.location.href = `${process.env.AMWAY_ROOT_URL}/login`;
        return next(false);
      }
  }
}
</script>

<style>
@import './font_kr.css';
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/style.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common-new-v2.css');

.bod-view-txt{padding-top:0}

/* radio btn */
.os_noticeRes .amway-theme .NCACroa_radioBtn label{margin-bottom:0;}
.os_noticeRes .amway-theme .NCACroa_radioBtn .radio-label input.amw-global-radio:checked + .amw-radio-overlay:before{background:#33597e; width:8px; height:8px; top:4px; left:4px;}
.os_noticeRes .amway-theme .NCACroa_radioBtn .radio-label input.amw-global-radio:checked + .amw-radio-overlay:after{border:2px solid #33597e; width:18px; height:18px; border-radius: 50%; content: ''; display:block; top: 50%; left: 50%; transform: translate(-50%, -50%); position:absolute;}
  
/* 참가자 정보 */
.os_noticeRes .NCACroa_cont01{display:flex; align-items: center; justify-content: space-between;}
.os_noticeRes .NCACroa_cont01_radio{display:flex; justify-content:space-between;}
.os_noticeRes .NCACroa_cont01_radio label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative; top:-3px;}
  
.os_noticeRes .NCACroa_cont01_wrap .NCACroa_cont01-1{display:flex; align-items: center; justify-content: space-between; border-bottom:1px solid #e3e3e3;}
.os_noticeRes .NCACroa_cont01_input input{width:55%;}
.os_noticeRes .NCACroa_cont01_wrap .NCACroa_cont01-2{display:flex; align-items: center; justify-content: flex-end; border-bottom:1px solid #e3e3e3;}

.os_noticeRes .NCACroa_cont01-1 label, .os_noticeRes .NCACroa_cont01-2 label{color:#56565A; margin-bottom:0;}
.os_noticeRes .NCACroa_cont01_file01{display:flex; justify-content: space-between; align-items: center; color:#56565A; margin-bottom:0;}
.os_noticeRes .NCACroa_cont01_file01 span.NCACroa_fileBtn, .os_noticeRes .NCACroa_cont01_file02 span.NCACroa_fileBtn{background: #7d8c9b; border-radius: 5px; font-weight: 500; color: #fff; height: 40px; text-align: center; padding-top: 0.5em; width:55%; display:inline-block;}
.os_noticeRes .NCACroa_cont01_file01 span.NCACroa_fileBtn.disabled, .os_noticeRes .NCACroa_cont01_file02 span.NCACroa_fileBtn.disabled {color: #fff; border-color: #bbb !important; background: #bbb !important;}
.os_noticeRes .NCACroa_cont01_file02{display:flex;justify-content: end; align-items: center; color:#56565A; margin-bottom:0;}
  
.os_noticeRes .NCACroa_cont01_wrap .NCACroa_cont01-2.NCACroa_pc{height:71px;}
.os_noticeRes .NCACroa_pc02 label{height:90px; display: flex; align-items: flex-start;}
.os_noticeRes input.NCACroa_num[type="number"]{padding:0 8px;}
.os_noticeRes .NCACroa_familyWrap{padding-bottom:30px; padding-top:30px;}

.os_noticeRes input.NCACroa_num[type="number"]::-webkit-outer-spin-button, .os_noticeRes input.NCACroa_num[type="number"]::-webkit-inner-spin-button {-webkit-appearance: none; margin: 0;}

/* 참가 약관 동의 */
.os_noticeRes .NCACroa_cont02_radio label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative;}
.os_noticeRes .NCACroa_cont02{display: flex; align-items: center; justify-content: space-between;}
.amway-theme .NCACroa_cont02_radio label.amw-radio-wrap .amw-radio-overlay{top:3px;}
  
/* 참가 약관 동의 팝업 공통 */
.NCACroa_cont02_popUp .cart-popup__header{background:#fff;}
.NCACroa_cont02_popUp .cart-popup__item-info{border-top:1px solid #ddd;}
.os_noticeRes .NCACroa_cont02_popUp thead th{ color:#00305e; font-weight:500; background:#f4f4f4;}
.os_noticeRes .NCACroa_cont02_popUp tbody tr td:nth-child(3){color:#2c2c2c; font-weight:500; font-size:17px;}
.os_noticeRes .NCACroa_cont02_popUp tbody tr:nth-child(even){background:#f4f4f4;}

.os_noticeRes .NCACroa_agreePop{display: flex; align-items: center; justify-content: space-between;}
.os_noticeRes .NCACroa_agreePop label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative;}
.os_noticeRes .NCACroa_agreePop .radio-label + .radio-label{margin-left:10px !important;}
  
/* 액티비티 예약 */
.os_noticeRes a.NCACroa_arrow{width:100%; border-radius:5px; padding:1em 0;}
.os_noticeRes .NCACroa_cont03_radio label .amw-label-radio-text em{color:#808285;}
.amway-theme .NCACroa_cont03_radio input.amw-global-radio{top:0; width:18px; height:18px;}
.os_noticeRes .NCACroa_cont03_radio .radio-label + .radio-label{margin-left:0 !important;}
.os_noticeRes .NCACroa_cont03_radio label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative; top:-3px;}
.os_noticeRes .amway-theme .NCACroa_cont03_radio label{margin-bottom:.7em;}

/* 액티비티 예약 radio off */
.os_noticeRes .NCACroa_cont03_radio label.NCACroa_radio_off .amw-label-radio-text, .akl .NCACroa_cont03_radio label.NCACroa_radio_off .amw-label-radio-text em{color:#bbbbbb;}
.os_noticeRes .amway-theme label.amw-radio-wrap.NCACroa_radio_off .amw-radio-overlay{background:#f4f4f4; border:1px solid #ddd;}
  
/* 제출 */
.bt-akl-blue.large.NCACroa_submit{width:100%; background:#00305e; border: 1px solid #00305e; border-radius:10px;}
.bt-akl-blue.large.NCACroa_submit.disabled{color: #fff !important; border-color: #bbb !important; background: #bbb !important;}
.os_noticeRes .bt-akl-blue.NCACroa_submit:hover{border:1px solid #00305e; color:#00305e; background:#fff;}

.bt-akl-blue.btn_close.NCACroa_cont03_popup{color:#fff;}
.bt-akl-blue.btn_close.NCACroa_cont03_popup:hover{color:#002F5F;}

/* file Box */
.NCACroa_cont01_file01.NCAfile_remove{justify-content: flex-end;}
.NCACroa_cont01_file01.NCAfile_remove input{height: 40px; width: 55%; border-radius: 5px; padding-right: 30px;}
.NCACroa_cont01_file01 a{position:absolute; background:none; padding-right:8px;}
  
@media screen and (max-width:639px) {
  body{margin:0 auto}
  .os_noticeRes .widM.cont_Wrap{width:100%;}
  .os_noticeRes .NCACroa_cont02 .floL, .os_noticeRes .NCACroa_cont02 .floR, .os_noticeRes .NCACroa_agreePop .floL, .os_noticeRes .NCACroa_agreePop .floR{margin:0;}
  .os_noticeRes .NCACroa_cont01_wrap .NCACroa_cont01-2, .os_noticeRes .NCACroa_cont01_file02{display:flex; align-items: center; justify-content: space-between;}
  .os_noticeRes .NCACroa_cont01_wrap .NCACroa_cont01-1 .amway-theme label:nth-child(2), .os_noticeRes .NCACroa_cont01_wrap .NCACroa_cont01-2 .amway-theme label:nth-child(2){margin-right:1.5em;} 
  .os_noticeRes .NCACroa_cont01_radio label .amw-label-radio-text{top:0;}
  .os_noticeRes .NCACroa_cont01_file01 span.NCACroa_fileBtn, .os_noticeRes .NCACroa_cont01_file02 span.NCACroa_fileBtn{padding-top:.7em;}

  .os_noticeRes .NCACroa_cont01_radio label .amw-label-radio-text, .os_noticeRes .NCACroa_cont02_radio label .amw-label-radio-text, .os_noticeRes .NCACroa_cont03_radio label .amw-label-radio-text, .os_noticeRes .NCACroa_agreePop label .amw-label-radio-text{font-size:16px;}
  .os_noticeRes .NCACroa_cont01_wrap .NCACroa_cont01-2.NCACroa_pc, .os_noticeRes .NCACroa_pc02{display:none;}
  .os_noticeRes .NCACroa_familyWrap{padding-bottom:15px; padding-top:15px;}

  .os_noticeRes .NCACroa_cont01_wrap.widM{width:100%;}
  .os_noticeRes .NCACroa_cont01_wrap.widM .floL, .os_noticeRes .NCACroa_cont01_wrap.widM .floR{width:95% !important; margin:0 auto;}

  .os_noticeRes .NCACroa_cont02_popUp tbody tr td:nth-child(3){color:#2c2c2c; font-weight:500; font-size:16px;}
}
</style>


// WEBPACK FOOTER //
// src/views/survey/Survey.vue